import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import ContactForm from "../contact/ContactForm";
import "./TONearbySupport.css";

const supportEmail = "kordikmail@gmail.com";
const metaDescription = "Support page for the TONearby mobile app.";

const supportFields = [
  {
    name: "deviceModel",
    placeholder: "Device model",
  },
  {
    name: "appDetails",
    placeholder: "iOS or Android version and app version",
  },
];

function TONearbySupport() {
  useEffect(() => {
    const previousTitle = document.title;
    let description = document.querySelector('meta[name="description"]');
    const previousDescription = description && description.getAttribute("content");
    const createdDescription = !description;

    if (!description) {
      description = document.createElement("meta");
      description.setAttribute("name", "description");
      document.head.appendChild(description);
    }

    document.title = "TONearby Support";
    description.setAttribute("content", metaDescription);

    return () => {
      document.title = previousTitle;

      if (createdDescription) {
        description.remove();
      } else if (previousDescription) {
        description.setAttribute("content", previousDescription);
      }
    };
  }, []);

  return (
    <main className="tonearby-support">
      <Container className="tonearby-support__container">
        <section className="tonearby-support__intro">
          <p className="tonearby-support__eyebrow">TONearby</p>
          <h1>TONearby Support</h1>
          <p>
            Need help with TONearby? Use the contact form below to send bug
            reports, data issues, feature suggestions, or other feedback.
          </p>
          <p>
            You can also contact support directly at:{" "}
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>
          <p>
            When contacting support, please include your device model, iOS or
            Android version, app version, and a short description of the issue.
          </p>
          <p>
            TONearby helps users find nearby Toronto parks, community centres,
            drop-in activities, and facility details.
          </p>
          <p>
            Privacy Policy:{" "}
            <a href="https://kordik.ca/tonearby/privacy">
              https://kordik.ca/tonearby/privacy
            </a>
          </p>
        </section>

        <ContactForm
          className="tonearby-support__form"
          title="Contact TONearby support"
          description="Send a bug report, data correction, feature suggestion, or other app feedback."
          formSubject="New TONearby support request"
          nextUrl="https://kordik.ca/tonearby/support"
          secondaryFields={supportFields}
          subjectPlaceholder="Support topic"
          messagePlaceholder="Describe the issue or feedback. Include the park, facility, activity, or screen where it happened if relevant.*"
          submitLabel="Send support request"
          hiddenFields={[{ name: "source", value: "TONearby support page" }]}
        />
      </Container>
    </main>
  );
}

export default TONearbySupport;
